import { Box } from "@mui/material";
import { SIDEBAR } from "../theme/theme";

export const BaseLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        height: "100vh",
        backgroundColor: SIDEBAR.bg, // bg-bg-secondary
        fontFamily:
          '"Geist", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
        overflow: "hidden",
      }}
    >
      {/* Main layout container */}
      <Box sx={{ display: "flex", height: "100vh" }}>
        {/* Main content area */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            backgroundColor: SIDEBAR.bg, // bg-hover
          }}
        >
          {/* Content - scrollable area */}
          <Box
            sx={{
              flex: 1,
              overflow: "auto",
              margin: "8px",
              backgroundColor: SIDEBAR.itemActiveBg, // bg-bg-primary
              borderRadius: "12px", // rounded-xl
              position: "relative",
              p: 2,
              maxHeight: "calc(100vh - 16px)",
              maxWidth: "calc(100vw - 16px)",
            }}
          >
            <Box
              sx={{
                transition: "margin-right 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
                marginRight: {
                  xs: 0,
                  md: 0,
                },
                flex: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: "100%",
              }}
            >
              {children}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
